export default {
  nav: {
    title: 'Checklists',
    templates: 'Checklist Templates',
  }
}
